import { ShieldCheckIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { formatDate } from './domain-overview.helper'

export interface SslCardProps {
  sslIssuer: string
  sslExpiresAt: string
}

export const SslCard: React.FC<SslCardProps> = ({ sslIssuer, sslExpiresAt }): ReactNode => (
  <Card className="ssl-info-card">
    <CardHeader className="pb-3">
      <CardTitle className="flex items-center gap-2 text-base">
        <ShieldCheckIcon className="size-4 text-green-500" />
        SSL Certificate
      </CardTitle>
    </CardHeader>
    <CardContent className="grid gap-3 text-sm">
      <div className="flex justify-between">
        <span className="text-muted-foreground">Issuer</span>
        <span className="font-medium">{sslIssuer}</span>
      </div>
      <div className="flex justify-between">
        <span className="text-muted-foreground">Expires</span>
        <span className="font-medium">{formatDate(sslExpiresAt)}</span>
      </div>
    </CardContent>
  </Card>
)
